export default __webpack_public_path__ + "dist/images/MichealsNew-ab5c9c114530312b9dc2cd652bb08f90.svg";